<template>
  <section class="page-hospital-form">
    <Breadcrumbs :items="breadcrumbs" />

    <div class="content">
      <rp-hospital-form
        @submit="addHospital"
        v-model="form"
        :isAdmin="isAdmin"
        :countries="countries" />

      <terms/>
      <rp-overlay :active="active">
        <rp-alert
          icon="done"
          :message="successMessage"
          :onClick="successFunction" />
      </rp-overlay>
    </div>
  </section>
</template>

<script>
  import HospitalForm from 'raypro_ui/src/components/ui/forms/Hospital'
  import {createHospital} from 'raypro_ui/src/api/hospitals'
  import {createUserHospitals} from 'raypro_ui/src/api/users'
  import {getCountries} from 'raypro_ui/src/api/countries'
  import Overlay from 'raypro_ui/src/components/ui/Overlay'
  import Alert from 'raypro_ui/src/components/ui/Alert'
  import page from '@/mixins/page'
  import {mapGetters} from 'vuex'

  import Terms from '@/components/Terms'
  import Breadcrumbs from '@/components/Breadcrumbs'

  export default {
    data() {
      return {
        errors: {},
        form: {assign_hospital: true, logo: {dataUrl: null}},
        countries: [],
        active: false,
        successMessage: 'Hospital added successfully!',
        breadcrumbs: [
          {
            label: 'All Hospitals',
            link: 'hospitals'
          },
          {label: 'Add Hospital'}
        ],
        title: 'Add Hospital'
      }
    },

    mixins: [page],

    mounted() {
      getCountries().then(({data}) => {
        this.countries = data.map((country) => {
          return {
            name: country.name,
            id: country.id,
            code: country.code
          }
        })
      })
    },

    computed: {
      ...mapGetters(['authUser']),

      isAdmin() {
        return this.authUser && this.authUser.roles.map((el) => { return el.name }).indexOf('raypro_admin') !== -1
      },

      hospitalPayload() {
        const form = this.form

        let hospital = {
          hospital: {
            'town': form.town,
            'postcode': form.postcode,
            'name': form.name,
            'county': form.county,
            'country_id': form.country.id,
            'address_1': form.address_1,
            'address_2': form.address_2,
            'latlng': [form.latitude, form.longitude]
          }
        }

        // Only add logo_data_uri to payload if it has a value
        if (form.logo.dataUrl && form.logo.dataUrl !== '') {
          hospital.hospital['logo_data_uri'] = form.logo.dataUrl
        }

        return hospital
      },

      getUserId() {
        return this.authUser.id
      },
    },

    components: {
      'rp-hospital-form': HospitalForm,
      'rp-overlay': Overlay,
      'rp-alert': Alert,
      Terms,
      Breadcrumbs
    },

    methods: {
      successFunction() {
        this.$router.push({name: 'hospitals'})
      },

      addHospital() {
        createHospital(this.hospitalPayload)
          .then(({data}) => {
            if(this.form.assign_hospital) {
              const hospitalId = data.id
              const payload = {
                id: this.getUserId,
                hospitalId
              }

              return createUserHospitals(payload).then(() => {
                this.active = true
              })
            }

            this.active = true
          })
          .catch(({response}) => {
            // TODO: map errors to flat structure for form
            this.errors = response.errors
          })
      }
    }
  }
</script>

<style lang="sass">
</style>



// WEBPACK FOOTER //
// src/components/pages/Hospitals/AddHospital.vue